module.exports = __webpack_public_path__ + "img/b010_1.18995b99.jpeg";